import { FilterKey } from "@/models/FilterKey";
import { IFilterProvider } from "@/interfaces/filter-providers/IFilterProvider";
import Filter from "../../Filter.class";

export default class DurationFilter extends Filter {
	constructor(filterProvider: IFilterProvider) {
		super(FilterKey.DURATION, filterProvider);
	}
}
